import { memo } from 'react';

import { NoSearchResults } from '~/components/NoSearchResults/NoSearchResults';
import { usePublicShowcaseContext } from '~/providers/PublicShowcaseProvider';

export const PublicShowcaseEmptySearchResultsState = memo(() => {
  const { collection } = usePublicShowcaseContext();

  return <NoSearchResults hideHelpLink location={collection.name} />;
});

PublicShowcaseEmptySearchResultsState.displayName = 'PublicShowcaseEmptySearchResultsState';
